import React from 'react';
import Home from '../components/home';
import Footer from '../components/common/Footer';

const Wiki = () => {
  return (
    <>
      <Home />
      <Footer />
    </>
  );
};

export default Wiki;
